export default "__VITE_ASSET__CyPasPNR__"